import React from 'react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Page from '../../../components/page/page'
import PageHeader from '../../../components/page/pageHeader'
import { CustomIframe } from '../../../components/shared/customIframe/customIframe'
import { getActiveBalanceZone, getActiveCompany, getCustomerDomain } from '../../../redux'

export interface ContractsLoadPageProps {}

export const ContractsLoadPage: React.FC<ContractsLoadPageProps> = props => {
  const apiSuffixUrl = 'https://' + getCustomerDomain()
  const [t] = useTranslation(['globalerisLibrary', 'translation', 'massiveProcess'])

  // const apiSuffixUrl = 'https://localhost:44394';
  let activeCompany = getActiveCompany()
  let activeBalanceZone = getActiveBalanceZone()
  const [routeLocal, setRouteLocal] = useState(`${apiSuffixUrl}/Contratos/Carga`)

  useEffect(() => {
    call()
  }, [activeCompany, activeBalanceZone])

  const call = async () => {
    setRouteLocal(
      `${apiSuffixUrl}/company/index/${activeCompany?.id}?idBalanceZone=${activeBalanceZone?.id}&company=${activeCompany?.description}&balanceZoneDescription=${activeBalanceZone?.description}`
    )

    setTimeout(() => {
      setRouteLocal(`${apiSuffixUrl}/Contratos/Carga`)
    }, 1000)
  }

  return (
    <Page>
      <PageHeader title={t('massiveProcess:contracts')} />
      <CustomIframe
        route={decodeURI(routeLocal)}
        width="100%"
        height="1200"
        allowFullScreen={true}
      />
    </Page>
  )
}
